import React from 'react';
import { Table } from '@mantine/core';
import { EntityParams } from 'app/models/entity-params';

type Props = {
    data: EntityParams[];
    handleSelectChange: (value: string) => void;
    searchValue: string;
};

export function TradeEntryEntityTable({ data, searchValue, handleSelectChange }: Props) {

    const escapeRegExp = (string: string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    // Helper function to highlight matching text
    const highlightText = (text: string) => {
        if (!searchValue) return text; // Return original text if search value is empty

        const escapedSearch = escapeRegExp(searchValue);
        const parts = text.split(new RegExp(`(${escapedSearch})`, 'gi')); // Safe regex
        return parts.map((part, index) =>
            part.toLowerCase() === searchValue.toLowerCase() ? (
                <span key={index} className='tradeSearchResult'>{part}</span>
            ) : (
                part
            )
        );
    };

    return (
        <div className='tradeTableContainer'>
            <div className='tradeTableScroll'>
                <Table
                    highlightOnHover
                    className="tradeTable"
                >
                    <thead>
                        <tr>
                            <th>
                                Entity Name
                            </th>
                            <th>
                                Entity ID
                            </th>
                            <th>
                                Internal ID
                            </th>
                            <th>
                                MEI
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((e) => (
                            <tr
                                key={e.id}
                                onClick={() => handleSelectChange(e.id ?? '')}
                            >
                                <td>{highlightText(e.entityName ?? '')}</td>
                                <td>{highlightText(e.systemId ?? '')}</td>
                                <td>{highlightText(e.internalId ?? '')}</td>
                                <td>{highlightText(e.mei ?? '')}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>

    );
}
